import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenerateSelectionComponent } from './generate-selection.component';
// PrimeNG Modules
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';



@NgModule({
  declarations: [
    GenerateSelectionComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    ButtonModule,
    InputTextModule
  ],
  exports: [
    GenerateSelectionComponent
  ]
})
export class GenerateSelectionModule { }
